import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SEOService {
  private renderer: Renderer2;
  private newCanonicalUrl = 'https://verlanglijst.online';

  constructor(
    private meta: Meta,
    private title: Title,
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  updateCanonicalLink(path: string) {

    let canonicalLink = this.document.querySelector('link[rel="canonical"]');
    this.newCanonicalUrl = this.newCanonicalUrl + path;
    if (canonicalLink) {
      // Update existing canonical tag
      this.renderer.setAttribute(canonicalLink, 'href', this.newCanonicalUrl);
    } else {
      // Create and append new canonical tag if it doesn't exist
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', this.newCanonicalUrl);
      this.renderer.appendChild(this.document.head, link);
    }
  }
} 